// Company Setup and Edit Mixin
export const company = {
  data() {
    return {
      company_details: {
        logo: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/company-logo.png",
        cover_pic:
          "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
        company_name: "",
        company_type: "",
        number_of_employees: "",
        date_of_incorporation: null,
        company_domain: [],
        about: "",
        time_zone: "",
        tax_id: "",
        currency: "",
        primary_email: "",
        primary_phone: {
          phone_type: "primary",
          phone_number: "",
          country_code: "",
          dial_code: "",
          //isvalid: "",
        },
        // secondry_phone: {
        //   phone_type: "secondry",
        //   phone_number: "",
        //   country_code: "",
        //   dial_code: "",
        //   //isvalid: "",
        // },
        // fax: "",
        website: "",
        email: [],
        phone_details: [],
        // social_media_new: {
        //   facebook: {
        //     account_type: "Facebook",
        //     account_url: "",
        //   },
        //   twitter: {
        //     account_type: "Twitter",
        //     account_url: "",
        //   },
        //   linkedin: {
        //     account_type: "Linkedin",
        //     account_url: "",
        //   }
        // },
        social_media: [
          {
            account_type: "Facebook",
            account_url: "",
          },
        ],
        branches: [
          {
            code: "",
            name: "",
            website: "",
            primary_phone: {
              phone_type: "primary",
              phone_number: "",
              country_code: "",
              dial_code: "",
              //isvalid: "",
            },
            primary_email: "",
            email: [],
            phone_details: [],
            departments: [],
            department: "",
            address: {
              address_type: "",
              building_number: "",
              street: "",
              street2: "",
              city: "",
              township: "",
              state: "",
              zip_code: "",
              country: "",
              longitude: "",
              latitude: "",
              meeting_location_vmodel: "",
            },
            google_maps_url: "",
          },
        ],
        fiscal_year: "Test",
        fiscal_year_start_date: "2020-04-29T18:30:00.000Z",
        fiscal_year_end_date: "2020-05-01T18:30:00.000",
        admin_details: {
          full_name: "",
          department: "",
          branch: "",
          email_id: "",
          password: "",
          phone: {
            phone_type: "",
            phone_number: "",
            country_code: "IN",
            dial_code: ""
          }
        }
      },
      primaryEmailExists: false,
      primaryEmailValid: true,
      adminEmailValid: true,
      adminEmailExists: false,
      userPrimaryEmailExists: 0,
      companyNameExists: false,
      BranchCodeExists: false,
      branchCodeDuplicates: [],
      branchData: {
        code: "",
        name: "",
        website: "",
        primary_phone: {
          phone_type: "primary",
          phone_number: "",
          country_code: "",
          dial_code: ""
          //isvalid: "",
        },
        primary_email: "",
        email: [],
        phone_details: [],
        departments: [],
        address: {
          address_type: "",
          building_number: "",
          street: "",
          street2: "",
          city: "",
          township: "",
          state: "",
          zip_code: "",
          country: "",
          longitude: "",
          latitude: "",
          meeting_location_vmodel: "",
        },
        google_maps_url: "",
      },
      address: {
        street: "",
        city: "",
        township: "",
        state: "",
        zipcode: "",
        country: "",
        longitude: "",
        latitude: "",
      },
      customPhoneType: "",
      customEmailType: "",
      encoded_image: "",
      BranchCustomEmailType: "",
      BranchCustomPhoneType: "",
      addressData: {
        street: "",
        city: "",
        township: "",
        state: "",
        country: "",
        zip_code: "",
        longitude: "",
        latitude: "",
      },
      customUserEmailType: "",
      customUserPhoneType: "",
      profile_pic: "",
      products_access: "",
      showPassword: false,
      errorMessage: "",
      validPhone: true,
      saveClicked: false,
      companyData: {},
      domainValid: true,
      departments: [],
      branchName: [],
      domains: [],
      domainIncorrect: false,
      publicDomain: false,
      branchCodeDuplicatesFound: false,
      timeZone: "",
    };
  },
  methods: {

    addBranch(e) {
      this.branchName = []
      this.branchName.push(e.target.value)
    },
    addDepartment(index) {
      // this.departments.push(e.target.value)
      this.company_details.branches[index].departments.push(this.company_details.branches[index].department)
    },
    updateDepartment(index) {
      this.company_details.branches[index].departments = []
      this.company_details.branches[index].departments.push(this.company_details.branches[index].department)
    },

    //Allow Public Domain
    async allowpublicdomain() {
      if (!this.publicDomain) {
        this.selecteddomainname = "";
        this.selected_admin_domain = "";
        this.domains = [];
        this.getDomainNames();
      } else if (this.publicDomain) {
        let params = {
          search_key: "",
          skip: 0,
          limit: 10
        };
        let res = await this.$http.post("/search_domain", params);
        if (res.data.status_id == 1) {
          res.data.response.forEach(x => {
            this.domains.push(x);
          });
        }
      }
    },

    async searchDomains(key) {
      this.domains = [];
      let params = {
        search_key: key,
        skip: 0,
        limit: 10
      };
      let res = await this.$http.post("/search_domain", params);
      if (res.data.status_id == 1) {
        this.domains = [];
        res.data.response.forEach(x => {
          this.domains.push(x);
        });
      }
    },

    // Checking Primary Email Exists and Validation, Comapny Name Exists Function
    checkExists() {
      if (!this.primaryEmailExists && this.primaryEmailValid && !this.companyNameExists && this.checkBranchExists()) {
        return true;
      } else {
        return false;
      }
    },

    // Checking Primary Email Exists and Validation API
    checkPrimaryEmail() {
      let emailToCheck = "";
      if (this.selecteddomainname && this.selected_company_domain) {
        emailToCheck = this.selected_company_domain + '@' + this.selecteddomainname;
        this.$http
          .post("/check_email_validity", {
            email_id: emailToCheck,
            email_type: "business",
            allow_public_domain: this.publicDomain
          })
          .then(response => {
            if (response.data.status_id == 1) {
              this.primaryEmailExists = response.data.exists;
              // this.primaryEmailValid = response.data.valid;
            }
          })
          .catch(error => {
            console.log(error);
          });
        return this;
      }
    },

    checkAdminEmail() {
      let emailToCheck = "";
      if (this.selected_admin_domain && this.selected_admin_email) {
        emailToCheck = this.selected_admin_email + '@' + this.selected_admin_domain;
        this.$http
          .post("/check_email_validity", {
            email_id: emailToCheck,
            email_type: "business",
            allow_public_domain: this.publicDomain
          })
          .then(response => {
            if (response.data.status_id == 1) {
              this.adminEmailExists = response.data.exists;
              // this.adminEmailValid = response.data.valid;
            }
          })
          .catch(error => {
            console.log(error);
          });
        return this;
      }
    },

    // Checking Comapny Name Exists API
    checkCompanyName() {
      if (this.company_details.company_name.length) {
        let data = {
          company_name: this.company_details.company_name.trim()
        }
        if (this.$route.params) {
          data.company_id = this.$route.params.id
        }
        this.$http.post("/company/check_company_name", data).then(response => {
          this.companyNameExists = response.data.exists;
        }).catch(error => {});
      }
    },

    // Checking Comapny Branch Exists
    checkBranchExists() {
      var branchCodesArray = this.company_details.branches.map(
        branch => branch.code
      );
      let findDuplicates = arr =>
        arr.filter((item, index) => arr.indexOf(item) != index);
      this.branchCodeDuplicates = [
        ...new Set(findDuplicates(branchCodesArray)),
      ];
      if (this.branchCodeDuplicates.length) {
        this.branchCodeDuplicates.forEach(x => {
          if (x !== "") {
            this.branchCodeDuplicatesFound = true;
            return true;
          }
        });
      } else {
        this.branchCodeDuplicatesFound = false;
        return false;
      }
    },

    // Edit Company Function
    editCompany(edit_data) {
      if (this.company_details.date_of_incorporation == null) {
        delete this.company_details["date_of_incorporation"];
      }
      this.company_details.branches.forEach(x => {
        delete x['department'];
        delete x.address['meeting_location_vmodel'];
        if (!(x.address.latitude)) {
          delete x.address["latitude"];
        }
        if (!(x.address.longitude)) {
          delete x.address["longitude"];
        }
      })
      this.ajaxCallinprogress = true
      this.$http
        .post("/company/edit_company", {
          edit_data: edit_data,
        })
        .then(response => {
          if (response.data.status_id == 1) {
            //alert("saved Successfully");
            this.$swal({
              title: "Success!",
              text: "Successfully Edited Your Company",
              type: "success",
              confirmButtonText: "OK",
              confirmButtonColor: "#005dae",
            }).then(() => {
              this.$router.go(-1);
            });
          }
          this.ajaxCallinprogress = false
        })
        .catch(error => {
          console.log(error);
          this.$swal({
            title: "Error!",
            text: "Company Not Edited",
            type: "warning",
            confirmButtonText: "OK",
            confirmButtonColor: "#005dae",
          });
        });
    },

    // Load Company Based on Company ID API
    loadcompanyData(account_data) {
      this.$http
        .post("/company/get_company_details", { company_id: account_data })
        .then(response => {
          if (response.data.status_id == 1) {
            this.company_details = response.data.response;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    // Load Company Based on Account API
    GetCompanyData(account_data) {
      this.ajaxCallinprogress = true;
      this.$http
        .post("/company/get_company_details", { account_id: account_data })
        .then(response => {
          if (response.data.status_id == 1) {
            this.companyData = response.data.response;
            this.ajaxCallinprogress = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    validateInput(scope) {
      if (scope == "companyData") {
        return this.checkExists() && this.$validator.validateAll(scope);
      }
      return this.$validator.validateAll(scope);
    },
    EncodeImage() {
      this.encoded_image = btoa(this.company_details.logo);
      //console.log("this.encoded_image");
    },

    // Getting User Companies API
    // getUserCompanines() {
    //   this.$http.get("/employees/get_user_companies").then(res => {
    //     if (res.data.status_id == 1) {
    //       this.$store.commit("setUserAccounts", res.data.response);
    //     }
    //   });
    // },

    // Getting User Company Domains API
    async checkDomainName(domain_name) {
      return new Promise(async (resolve, reject) => {
        let response = await this.$http.post("/check_domain_names_validity", { domain_names: domain_name })
        resolve(response.data)
      })
    },

    // Getting Domains
    async getDomainNames() {
      let domainInitial = 0;
      this.company_details.company_domain.forEach(x => {
        if (x.includes('www.')) {
          domainInitial += 1;
        }
      });
      if (domainInitial == 0) {
        this.domainIncorrect = false;
      } else {
        this.domainIncorrect = true;
      }
      let domainNameValidation = await this.checkDomainName(this.company_details.company_domain);
      this.domainValid = domainNameValidation.valid;
      if (this.domainValid && !this.domainIncorrect) {
        this.domains = [];
        this.company_details.company_domain.forEach(x => {
          this.domains.push(x);
        });
      }
    },

    // Register Comapny APIs
    save_company_info() {
      this.saveClicked = true
      //this.company_details.time_zone = this.company_details.time_zone.value;
      var moment = require('moment');
      let str = this.company_details.date_of_incorporation;
      let date = moment(str)
      this.$validator.validateAll('companyData').then(result => {
        if (result && this.domainValid && !this.domainIncorrect && !this.primaryEmailExists && this.primaryEmailValid && !this.adminEmailExists && this.adminEmailValid && !this.companyNameExists && !this.branchCodeDuplicatesFound) {
          // this.company_details.primary_email = this.company_details.primary_email.trim() + '@' + this.selecteddomainname.trim()
          if (this.company_details.date_of_incorporation !== null) {
            this.company_details.date_of_incorporation = date.format();
          } else {
            delete this.company_details["date_of_incorporation"];
          }
          this.company_details.branches.forEach(x => {
            delete x['department']
            delete x.address['meeting_location_vmodel']
            if (!(x.address.latitude)) {
              delete x.address["latitude"];
            }
            if (!(x.address.longitude)) {
              delete x.address["longitude"];
            }
          });
          this.company_details.time_zone = this.timeZone.value;
          this.company_details.currency = {
            label: this.company_details.currency.label,
            symbol: this.company_details.currency.symbol
          };
          if (this.selected_company_domain) {
            this.company_details.primary_email = this.selected_company_domain + '@' + this.selecteddomainname;
          }
          this.company_details.admin_details.email_id = this.selected_admin_email + '@' + this.selected_admin_domain;
          this.$http.post("/company/register_company", this.company_details).then(res => {
            if (res.data.status_id == 1) {
              this.$swal({
                title: "Success!",
                text: "Successfully Created Your Company",
                type: "success",
                confirmButtonText: "OK",
                confirmButtonColor: "#005dae",
              }).then(() => {
                // this.getUserCompanines()
                this.$router.push({ path: "/managecompany" });
              });
            } else {
              //alert("Not Registered!");
              this.$swal({
                type: "error",
                title: 'Error!',
                text: 'Error While Creating Company',
                confirmButtonText: 'CLOSE',
                confirmButtonColor: "#005dae",
              }).then(() => {
                // this.getUserCompanines()
                this.$router.push({ path: "/managecompany" });
              });
            }
          });
        } else if (!result) {
          this.$swal({
            type: "warning",
            title: 'Alert!',
            text: 'Please Fill All The Required Fields',
            confirmButtonText: 'CLOSE',
            confirmButtonColor: "#005dae",
          })
          this.saveClicked = false
        } else if (result && this.companyNameExists) {
          this.$swal({
            type: "warning",
            title: 'Alert!',
            text: 'Company Name Already Exists!',
            confirmButtonText: 'CLOSE',
            confirmButtonColor: "#005dae",
          })
          this.saveClicked = false
        } else if (result && this.adminEmailExists) {
          this.$swal({
            type: "warning",
            title: 'Alert!',
            text: 'Admin Email Already Exists!',
            confirmButtonText: 'CLOSE',
            confirmButtonColor: "#005dae",
          })
          this.saveClicked = false
        }
      })
    },

    // Adding multi phone numbers
    phoneAdding(value) {
      this.company_details.phone_details.push(
        JSON.parse(
          JSON.stringify({
            phone_type: value,
            phone_number: "",
            //country_code: "",
            //isvalid: "",
          })
        )
      );
    },

    // Adding multi phone numbers
    customPhone() {
      this.company_details.phone_details.push(
        JSON.parse(
          JSON.stringify({
            phone_type: this.customPhoneType,
            phone_number: "",
            //country_code: "",
            //isvalid: "",
          })
        )
      );
      this.customPhoneType = "";
    },

    // Adding multi phone numbers
    BranchPhoneAdding(value, index) {
      this.company_details.branches[index].phone_details.push(
        JSON.parse(
          JSON.stringify({
            phone_type: value,
            phone_number: "",
            //country_code: "",
            //isvalid: "",
          })
        )
      );
    },
    // Adding multi phone numbers
    BranchCustomPhone(index) {
      this.company_details.branches[index].phone_details.push(
        JSON.parse(
          JSON.stringify({
            phone_type: this.BranchCustomPhoneType,
            phone_number: "",
            //country_code: "",
            //isvalid: "",
          })
        )
      );
      this.BranchCustomPhoneType = "";
    },

    // Adding multiple Emails
    emailAdding(value) {
      this.company_details.email.push(
        JSON.parse(JSON.stringify({ email_type: value, email_id: "" }))
      );
    },

    // Adding multiple Emails
    customEmail() {
      this.company_details.email.push(
        JSON.parse(
          JSON.stringify({ email_type: this.customEmailType, email_id: "" })
        )
      );
      this.customEmailType = "";
    },
    // Adding multiple Emails
    BrancEmailAdding(value, index) {
      this.company_details.branches[index].email.push(
        JSON.parse(JSON.stringify({ email_type: value, email_id: "" }))
      );
    },
    // Adding multiple Emails
    BranchCustomEmail(index) {
      this.company_details.branches[index].email.push(
        JSON.parse(
          JSON.stringify({
            email_type: this.BranchCustomEmailType,
            email_id: "",
          })
        )
      );
      this.BranchCustomEmailType = "";
    },

    // Adding multiple phone
    userPhoneAdding(value) {
      this.basic_information.phone_details.push(
        JSON.parse(
          JSON.stringify({
            phone_type: value,
            phone_number: "",
            //country_code: "",
            //isvalid: "",
          })
        )
      );
    },

  },

  created() {
    const dict = {
      custom: {
        company_name: {
          required: () => "Company Name is Required",
        },
        company_domain: {
          required: () => "Domain Name is Required",
          regex: () => "Please Add Valid URL (Ex: digicollect.com, acoinvestment.com)"
        },
        primary_email: {
          required: () => "Company Primary Email is Required",
          regex: () => "Please Enter Valid Name",
        },
        select_domain: {
          required: () => "Domain Selection is Required",
        },
        company_website: {
          required: () => "Enter Company Website Address",
          url: () => "Enter a Valid Website Address",
        },
        email: {
          // required: () => "Email is Required",
          // email: () => "Email is invalid. Please Enter Valid Email Address.",
          required: () => 'Email is Required',
          regex: () => 'Please Enter Valid Email'
        },
        admin_email: {
          required: () => 'Admin Email is Required',
          email: () => 'Please Enter a Valid Email'
        },
        admin_password: {
          required: () => 'Admin password is required',
          min: () => 'Admin password must be at least 8 characters long',
          regex: () => 'Admin password format is invalid',
        },
        company_type: {
          required: () => "Company Type is Required",
        },
        currency: {
          required: () => "Currency is Required",
        },
        number_of_employees: {
          required: () => "Number of Employees is Required",
        },
        date_of_incorporation: {
          required: () => "Date of Incorporation is Required",
        },
        time_zone: {
          required: () => "Time Zone is Required",
        },
        phone_number: {
          required: () => "Phone Number is Required",
          min: () => "Phone Number must Contain more than 7 Numbers",
          regex: () => "Phone Number must Contain Valid Format"
        },
        website: {
          required: () => "Website Address is Required",
        },
        street: {
          required: () => "Street is Required",
        },
        city: {
          required: () => "City is Required",
        },
        township: {
          required: () => "Township is Required",
        },
        state: {
          required: () => "State is Required",
        },
        pin_code: {
          required: () => "Zip Code is Required",
        },
        country: {
          required: () => "Please Select Country",
        },
        media_url: {
          require_protocol: () => "The URL must Contain Valid Format (Ex: http://www.digicollect.com)",
          regex: () => "Please Enter a Valid URL"
        },
      },
    };
    this.$validator.localize("en", dict);
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/companySetup.js